/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeInviteSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeInviteRequest = {
  /**
   * WorkOS invitation ID.
   */
  invitationId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type RevokeInviteSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeInviteSecurity$outboundSchema: z.ZodMiniType<
  RevokeInviteSecurity$Outbound,
  RevokeInviteSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeInviteSecurityToJSON(
  revokeInviteSecurity: RevokeInviteSecurity,
): string {
  return JSON.stringify(
    RevokeInviteSecurity$outboundSchema.parse(revokeInviteSecurity),
  );
}

/** @internal */
export type RevokeInviteRequest$Outbound = {
  invitation_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeInviteRequest$outboundSchema: z.ZodMiniType<
  RevokeInviteRequest$Outbound,
  RevokeInviteRequest
> = z.pipe(
  z.object({
    invitationId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      invitationId: "invitation_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function revokeInviteRequestToJSON(
  revokeInviteRequest: RevokeInviteRequest,
): string {
  return JSON.stringify(
    RevokeInviteRequest$outboundSchema.parse(revokeInviteRequest),
  );
}
